// Libs
import React from 'react';
import { Grid } from '@mui/material';

// Components
import OrderCardButtons from './OrderCardButtons';
import OrderCardQtyColumns from './OrderCardQtyColumns';
import OrderCardTrackingColumn from './OrderCardTrackingColumn';
import OrderCardShippingAddress from './OrderCardShippingAddress';
import OrderCardTime from './OrderCardTime';
import OrderCardStatus from './OrderCardStatus';
import OrderCardReorderColumn from './OrderCardReorderColumn';

// Hooks
import useOrderCard from './useOrderCard';

const OrderCard = ({
  order,
  onReorder,
  isDistro = false,
  withChildren = false,
  onToggleChildren = () => {},
  className,
}) => {
  const {
    productsObj,
    onAddToMyKits,
    isMobileMode,
    isTabletMode,
    classes,
    cx,
    gridPropValues,
    canReorder,
  } = useOrderCard({ order, withChildren });

  const buttons = (
    <OrderCardButtons
      order={order}
      isDistro={isDistro}
      isMobileMode={isMobileMode}
      gridPropValues={gridPropValues}
      onAddToMyKits={onAddToMyKits}
    />
  );

  return (
    <Grid
      container
      spacing={gridPropValues({
        lgSize: 2.5,
        mdSize: '10px',
      })}
      className={cx(className, classes.card)}
      data-testid="order-card">
      {!isMobileMode ? (
        <Grid
          item
          flexBasis={gridPropValues({
            lgSize: 5,
            mdSize: 12,
            unit: '%',
          })}
          maxWidth={gridPropValues({
            lgSize: 5,
            mdSize: 12,
            unit: '%',
          })}>
          {buttons}
        </Grid>
      ) : (
        buttons
      )}
      {!isMobileMode && (
        <OrderCardQtyColumns
          order={order}
          productsObj={productsObj}
          gridPropValues={gridPropValues}
          classes={classes}
          cx={cx}
        />
      )}
      <OrderCardTrackingColumn
        order={order}
        isDistro={isDistro}
        isMobileMode={isMobileMode}
        gridPropValues={gridPropValues}
        classes={classes}
        withChildren={withChildren}
        onToggleChildren={onToggleChildren}
      />
      <OrderCardShippingAddress
        order={order}
        isMobileMode={isMobileMode}
        isTabletMode={isTabletMode}
        gridPropValues={gridPropValues}
        classes={classes}
      />
      <OrderCardTime
        order={order}
        isMobileMode={isMobileMode}
        gridPropValues={gridPropValues}
        classes={classes}
        cx={cx}
      />
      <OrderCardStatus
        order={order}
        isMobileMode={isMobileMode}
        gridPropValues={gridPropValues}
        classes={classes}
      />
      <OrderCardReorderColumn
        order={order}
        isDistro={isDistro}
        isMobileMode={isMobileMode}
        isTabletMode={isTabletMode}
        canReorder={canReorder}
        onReorder={onReorder}
        gridPropValues={gridPropValues}
        classes={classes}
      />
    </Grid>
  );
};

export default OrderCard;
